module.exports = {"title":"Smile More.<br/>Pay Less.","image":"/media/pricing_cover.jpg","overlap":true,"trustpilot":true}